import { render, staticRenderFns } from "./BorderLink.vue?vue&type=template&id=04f32a64&scoped=true&"
import script from "./BorderLink.vue?vue&type=script&lang=js&"
export * from "./BorderLink.vue?vue&type=script&lang=js&"
import style0 from "./BorderLink.vue?vue&type=style&index=0&id=04f32a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f32a64",
  null
  
)

export default component.exports